//10px - 35px
export default [...Array(26).keys()].map(s => `${s + 10}px`);